import jQuery from 'jquery';
import 'bootstrap';
import VMasker from 'vanilla-masker';

window.$ = jQuery;
window.jQuery = jQuery;
window.VMasker = VMasker;

import 'fonts/index';